 
import {  getDrivers, assignDriver } from '@/api/driver' 

export const state = {
    loading_get_driver: false, 
    loading_assign_driver: false, 
    drivers: []
    
}

export const getters = {
    loading_get_driver: state => state.loading_get_driver, 
    loading_assign_driver: state => state.loading_assign_driver, 
    drivers: state => state.drivers, 
   
}
export const mutations = { 
    getDriver(state){
        state.loading_get_driver = true;
        state.drivers = []
    },
    getDriverDone(state, payload){
        state.loading_get_driver = false;
        state.drivers = payload
    },
    getDriverFail(state){
        state.loading_get_driver = false;
        state.drivers = []
    },
    assignDriver(state){
        state.loading_assign_driver = true;
        
    },
    assignDriverDone(state, payload){
        state.loading_assign_driver = false;
         
    },
    assignDriverFail(state){
        state.loading_assign_driver = false; 
    },
    
}

export const actions = {
    async getDrivers({ commit }, payload) {
        commit('getDriver');
        try {
            const response = await getDrivers(payload);
            commit('getDriverDone', response.data);
        } catch (error) {
            commit('getDriverFail');
            throw error
        }
    },
    async assignDriver({ commit }, payload) {
        commit('assignDriver');
        try {
            const response = await assignDriver(payload);
            commit('assignDriverDone', response.data);
        } catch (error) {
            commit('assignDriverFail');
            throw error
        }
    },
    
}